import KeplerSdk from './../../keplerSdk.js'

const state = {
    wallets: [],
    walletsLastFetch: null,
}

const mutations = {
    SET_WALLETS_LIST (state, message) {
        state.wallets = message
    },
    SET_WALLETS_LAST_FETCH (state, message) {
        state.walletsLastFetch = message
    },
}

const actions = {
    fetchWallets: ({commit}, payload) => {
        if (state.walletsLastFetch == null) {
            KeplerSdk.getWallets(function (data) {
                commit('SET_WALLETS_LAST_FETCH', Math.floor(Date.now() / 1000))
                commit('SET_WALLETS_LIST', data)
            }, function (error) {

            })
        }
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/frontoffice/walletsStore.js